// extracted by mini-css-extract-plugin
export default {"head_menu":"index_head_menu__izTNm"};